import { Wand2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface IdResolutionHintProps {
    message: string
    className?: string
}

export const IdResolutionHint = ({ message, className }: IdResolutionHintProps) => {
    return (
        <p className={cn('flex items-start gap-1.5 text-xs text-muted-foreground', className)}>
            <Wand2 className="w-3 h-3 flex-shrink-0 mt-0.5" />
            <span>{message}</span>
        </p>
    )
}
